import { render, staticRenderFns } from "./MultipleUpload.vue?vue&type=template&id=e560ea06&scoped=true&"
import script from "./MultipleUpload.vue?vue&type=script&lang=js&"
export * from "./MultipleUpload.vue?vue&type=script&lang=js&"
import style0 from "./MultipleUpload.vue?vue&type=style&index=0&id=e560ea06&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e560ea06",
  null
  
)

export default component.exports